/**
 * @file Logo List.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Logo List component.
 */
const vLogoList = () => {
	const logoList = document.querySelector('.v-logo-list');

	if (!logoList) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);
	const logoListBg = logoList.querySelector('.v-logo-list__bg-transition');

	ScrollTrigger.matchMedia({
		'(min-width: 1025px)': () => {
			const tl = gsap.timeline({
				defaults: {
					ease: 'sine.out',
				},
				scrollTrigger: {
					trigger: logoListBg,
					start:   'top bottom',
					end:     'bottom 75%',
					scrub:   true,
				},
			});

			tl.to(logoListBg, {
				scale: 1,
			});
		},
	});
};

export default vLogoList;
